// material-ui
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

// project imports
import { ThemeMode } from "config";

import iconDark from "assets/images/logo-toby-icon-dark.svg";
import icon from "assets/images/logo-toby-icon.svg";
import textDark from "assets/images/logo-toby-text-dark.svg";
import text from "assets/images/logo-toby-text.svg";

const ICON_HEIGHT = 32;
const TEXT_HEIGHT = 24;

export default function LogoMain() {
  const theme = useTheme();
  const isDark = theme.palette.mode === ThemeMode.DARK;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <img src={isDark ? iconDark : icon} alt="" height={ICON_HEIGHT} />
      <img src={isDark ? textDark : text} alt="TobyLabs" height={TEXT_HEIGHT} />
    </Box>
  );
}
